// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Fresnel$PrezzeeRibbon from "../../../bindings/Fresnel/Fresnel.bs.js";

function DeviceSizeImage(props) {
  var mobile = props.mobile;
  var tablet = props.tablet;
  var smallScreen = props.smallScreen;
  var desktop = props.desktop;
  var images;
  if (desktop !== undefined) {
    var d = Caml_option.valFromOption(desktop);
    if (smallScreen !== undefined) {
      var s = Caml_option.valFromOption(smallScreen);
      if (tablet !== undefined) {
        var t = Caml_option.valFromOption(tablet);
        images = mobile !== undefined ? ({
              desktop: d,
              smallScreen: s,
              tablet: t,
              mobile: Caml_option.valFromOption(mobile)
            }) : ({
              desktop: d,
              smallScreen: s,
              tablet: t,
              mobile: t
            });
      } else {
        images = mobile !== undefined ? ({
              desktop: d,
              smallScreen: s,
              tablet: s,
              mobile: Caml_option.valFromOption(mobile)
            }) : ({
              desktop: d,
              smallScreen: s,
              tablet: s,
              mobile: s
            });
      }
    } else if (tablet !== undefined) {
      var t$1 = Caml_option.valFromOption(tablet);
      images = mobile !== undefined ? ({
            desktop: d,
            smallScreen: d,
            tablet: t$1,
            mobile: Caml_option.valFromOption(mobile)
          }) : ({
            desktop: d,
            smallScreen: d,
            tablet: t$1,
            mobile: t$1
          });
    } else {
      images = mobile !== undefined ? ({
            desktop: d,
            smallScreen: d,
            tablet: d,
            mobile: Caml_option.valFromOption(mobile)
          }) : ({
            desktop: d,
            smallScreen: d,
            tablet: d,
            mobile: d
          });
    }
  } else if (smallScreen !== undefined) {
    var s$1 = Caml_option.valFromOption(smallScreen);
    if (tablet !== undefined) {
      var t$2 = Caml_option.valFromOption(tablet);
      images = mobile !== undefined ? ({
            desktop: s$1,
            smallScreen: s$1,
            tablet: t$2,
            mobile: Caml_option.valFromOption(mobile)
          }) : ({
            desktop: s$1,
            smallScreen: s$1,
            tablet: t$2,
            mobile: t$2
          });
    } else {
      images = mobile !== undefined ? ({
            desktop: s$1,
            smallScreen: s$1,
            tablet: s$1,
            mobile: Caml_option.valFromOption(mobile)
          }) : ({
            desktop: s$1,
            smallScreen: s$1,
            tablet: s$1,
            mobile: s$1
          });
    }
  } else if (tablet !== undefined) {
    var t$3 = Caml_option.valFromOption(tablet);
    images = mobile !== undefined ? ({
          desktop: t$3,
          smallScreen: t$3,
          tablet: t$3,
          mobile: Caml_option.valFromOption(mobile)
        }) : ({
          desktop: t$3,
          smallScreen: t$3,
          tablet: t$3,
          mobile: t$3
        });
  } else if (mobile !== undefined) {
    var m = Caml_option.valFromOption(mobile);
    images = {
      desktop: m,
      smallScreen: m,
      tablet: m,
      mobile: m
    };
  } else {
    images = {
      desktop: null,
      smallScreen: null,
      tablet: null,
      mobile: null
    };
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(Fresnel$PrezzeeRibbon.Media.make, {
                      greaterThanOrEqual: "rbDesktop",
                      children: images.desktop
                    }),
                JsxRuntime.jsx(Fresnel$PrezzeeRibbon.Media.make, {
                      at: "rbSmallScreen",
                      children: images.smallScreen
                    }),
                JsxRuntime.jsx(Fresnel$PrezzeeRibbon.Media.make, {
                      at: "rbTablet",
                      children: images.tablet
                    }),
                JsxRuntime.jsx(Fresnel$PrezzeeRibbon.Media.make, {
                      at: "rbMobile",
                      children: images.mobile
                    })
              ]
            });
}

var make = DeviceSizeImage;

export {
  make ,
}
/* react/jsx-runtime Not a pure module */
